{
  "dashboard.title": "忠誠儀表板",
  "actionReferralReportDownloadButton.tooltip": "推薦計劃報表是包含推薦資訊的 CSV 檔案，下載可能需要數分鐘的時間。",
  "actionReferralReportDownloadButton.label": "下載推薦計劃報表",
  "referralRevenueWidget.title": "淨營收和投資報酬率",
  "referralRevenueWidget.roiTotals.title": "投資報酬率",
  "referralRevenueWidget.roiTotals.titleTooltip": "在所選期間，除以投資的淨營收。",
  "referralRevenueWidget.investmentTotals.title": "投資",
  "referralRevenueWidget.investmentTotals.titleTooltip": "在所選期間，用於購買的推薦兌換券總成本。",
  "referralRevenueWidget.revenueTotals.title": "淨營收",
  "referralRevenueWidget.revenueTotals.titleTooltip": "在所選期間，減去所有折扣後的推薦購買總營收。",
  "referralRevenueWidget.chartMetaData.displayName.revenue": "淨營收",
  "referralRevenueWidget.chartMetaData.displayName.investment": "投資",
  "referralRevenueWidget.chartMetaData.displayName.roi": "投資報酬率",
  "referralSucccessWidget.chartMetaData.diaplayName.successRate": "成功率",
  "referralSucccessWidget.successRate.title": "成功率",
  "referralSucccessWidget.successRate.titleTooltip": "根據智慧洞察新近度設定，在所選期間推薦朋友兌換購買的推薦代碼百分比。",
  "referralSucccessWidget.title": "推薦成功率",
  "referralVouchersWidget.title": "推薦兌換券",
  "referralVouchersWidget.redeemedTotal.title": "兌換的兌換券",
  "referralVouchersWidget.redeemedTotal.titleTooltip": "推薦朋友兌換購買的推薦代碼總數量。",
  "referralVouchersWidget.issuedTotal.title": "發行的兌換券",
  "referralVouchersWidget.issuedTotal.titleTooltip": "忠誠成員傳送至推薦朋友的推薦代碼總數量。",
  "referralVouchersWidget.chartMetaData.issuedVouchers.displayName": "發行的兌換券",
  "referralVouchersWidget.chartMetaData.redeemedVouchers.displayName": "兌換的兌換券",
  "averageOrderValueWidget.title": "平均訂單價值",
  "averageOrderValueWidget.totals.nonLoyaltyMembers": "非忠誠成員",
  "averageOrderValueWidget.totals.loyaltyMembers": "忠誠成員",
  "averageOrderValueWidget.totals.uplift": "忠誠提升",
  "averageOrderValueWidget.chart.nonLoyaltyMembers": "非忠誠成員",
  "averageOrderValueWidget.chart.loyaltyMembers": "忠誠成員",
  "dashboardEmptyState.title": " 無資料可顯示。",
  "dashboardEmptyState.lead": "您沒有資料可顯示。",
  "dashboardView.loyaltyImpact.title": "忠誠影響",
  "dashboardView.numOfMembersWidget.title": "忠誠成員增長",
  "dashboardView.engagementRatesWidget.title": "忠誠互動",
  "dashboardView.pointsAnalyticsWidget.title": "獎勵分析",
  "engagementRatesWidget.title": "互動率",
  "engagementRatesWidget.totalsEngagement.ratePct.title": "忠誠互動率",
  "engagementRatesWidget.totalsRedemption.ratePct.title": "點數互動率",
  "inThePastDays": "過去 {selectedDaysRange} 天",
  "engagementRatesWidget.mainSeries.redemtion.name": "點數兌換率",
  "engagementRatesWidget.redemptionRateWidget.title": "點數兌換率",
  "engagementRatesWidget.redemptionRateWidget.titleTooltip": "根據智慧洞察新近度設定，在所選期間兌換獎勵的總點數百分比。",
  "engagementRatesWidget.engagementRateWidget.titleTooltip": "在所選期間中，從購買和行動累計點數或兌換點數取得獎勵的成員百分比。",
  "engagementRatesWidget.engagementRateWidget.title": "忠誠互動率",
  "engagementRatesWidget.chartMetaData.main.displayName": "忠誠互動率",
  "enrollmentsWidget.title": "忠誠登記",
  "enrollmentsWidget.totals.leadTotal.title": "登記的潛在客戶",
  "enrollmentsWidget.totals.customerTotal.title": "登記的成員",
  "enrollmentsWidget.totals.enrollTotal.title": "總登記",
  "enrollmentsWidget.tooltip.label": "忠誠登記",
  "enrollmentsWidget.chartMetaData.customer.displayName": "成員",
  "enrollmentsWidget.chartMetaData.lead.displayName": "潛在客戶",
  "generatedRevenueWidget.title": "忠誠成員營收",
  "generatedRevenueWidget.widgetCollapsedContentElement.totalRevenue.title": "總營收",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyRevenue.title": "忠誠營收",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyImpactPct.title": "忠誠營收影響",
  "generatedRevenueWidget.chartDataTotalRevenue.name": "總營收",
  "generatedRevenueWidget.chartDataLoyaltyRevenue.name": "忠誠營收",
  "generatedRevenueWidget.totals.loyaltyImpactPct.titleTooltip": "忠誠計劃產生的總營收百分比。",
  "generatedRevenueWidget.totals.loyaltyImpactPct.title": "忠誠營收影響",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.title": "忠誠行動營收",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.titleTooltip": "成員完成忠誠行動所產生的營收。",
  "generatedRevenueWidget.totals.loyaltyRevenue.title": "總忠誠營收",
  "generatedRevenueWidget.totals.loyaltyRevenue.titleTooltip": "在所選期間，忠誠成員所產生的總營收。",
  "generatedRevenueWidget.totals.totalRevenue.title": "總營收",
  "generatedRevenueWidget.totals.totalRevenue.titleTooltip": "總營收包含根據所選期間銷售資料的所有購買。總計也包含退回的項目 (退款)，這會減少總營收值。",
  "generatedRevenueWidget.chartTooltipContent.totalRevenue.label": "總營收",
  "generatedRevenueWidget.chartTooltipContent.loyaltyRevenue.label": "總忠誠營收",
  "generatedRevenueWidget.chartTooltipContent.totalActionRevenue.label": "忠誠行動營收",
  "generatedRevenueWidget.chartTooltipContent.loyaltyImpactPct.label": "忠誠營收影響",
  "numOfMembersWidget.title": "總忠誠成員",
  "numOfMembersWidget.total.title": "忠誠成員",
  "numOfMembersWidget.chartTooltipContent.label": "忠誠成員",
  "pointsAnalyticsWidget.title.spend": "消費獎勵分析",
  "pointsAnalyticsWidget.title.points": "點數分析",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.displayName": "累計消費獎勵",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.totalsTooltip": "所選期間的已確認消費獎勵總數量。",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.displayName": "累計現金回饋",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.totalsTooltip": "所選期間的已確認現金回饋總數量。",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.displayName": "待處理消費獎勵",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.totalsTooltip": "所選期間的待處理消費獎勵總數量。",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.displayName": "過期消費獎勵",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.totalsTooltip": "所選期間的過期消費獎勵總數量。",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.displayName": "累計點數",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.totalsTooltip": "所選期間的已確認消費獎勵總數量。",
  "pointsAnalyticsWidget.chartMetadata.points.pending.displayName": "待處理點數",
  "pointsAnalyticsWidget.chartMetadata.points.pending.totalsTooltip": "所選期間的待處理點數總數量。",
  "pointsAnalyticsWidget.chartMetadata.points.expired.displayName": "過期/移除點數",
  "pointsAnalyticsWidget.chartMetadata.points.expired.totalsTooltip": "所選期間的過期/移除點數總數量。",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.displayName": "兌換點數",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.totalsTooltip": "所選期間的兌換點數總數量。",
  "purchaseFrequencyWidget.title": "期間的購買次數",
  "purchaseFrequencyWidget.tooltip": "根據智慧洞察新近度設定，成員在所選期間的購買平均次數。",
  "purchaseFrequencyWidget.totalsMetaData.loyalty.title": "忠誠成員",
  "purchaseFrequencyWidget.totalsMetaData.nonLoyalty.title": "非忠誠成員",
  "purchaseFrequencyWidget.totalsMetaData.uplift.title": "忠誠提升",
  "vouchersAnalyticsWidget.title": "兌換券分析",
  "vouchersAnalyticsWidget.rewardMetaData.displayName": "獎勵兌換券",
  "vouchersAnalyticsWidget.rewardMetaData.totalsTooltip": "在所選期間，針對所顯示已完成行動和兌換券代碼的累計獎勵和固定福利兌換券總數量。",
  "vouchersAnalyticsWidget.pointsMetaData.displayName": "點數兌換券",
  "vouchersAnalyticsWidget.pointsMetaData.totalsTooltip": "在所選期間，針對所顯示兌換券代碼的累計點數兌換券總數量。",
  "vouchersAnalyticsWidget.freeMetaData.displayName": "免費兌換券",
  "vouchersAnalyticsWidget.freeMetaData.totalsTooltip": "在所選期間，針對所顯示兌換券代碼的累計免費兌換券總數量。",
  "vouchersAnalyticsWidget.cashbackMetaData.displayName": "現金回饋兌換券",
  "vouchersAnalyticsWidget.cashbackMetaData.totalsTooltip": "在所選期間，針對所顯示兌換券代碼的累計現金回饋兌換券總數量。",
  "widgetHelpLink.tooltip": "查看此資料的計算方式",
  "viewRange.options.day": "天",
  "viewRange.options.week": "週",
  "viewRange.options.month": "月"
}
